import { Injectable } from '@angular/core';

declare global {
  interface Window {
    JitsiMeetExternalAPI?: any;
  }
}

const JITSI_SCRIPT_ID = 'jitsi-external-api';
const JITSI_SCRIPT_SRC = 'https://meet.jit.si/external_api.js';

/**
 * Carga bajo demanda el script `external_api.js` de Jitsi (servidor público
 * meet.jit.si) e inyecta el global `window.JitsiMeetExternalAPI`. Calcado de
 * WhatsappMetaSdkService: inyecta una sola vez, cachea la promesa y resuelve
 * directo si el global ya existe.
 */
@Injectable({ providedIn: 'root' })
export class JitsiSdkService {
  private sdkPromise: Promise<any> | null = null;

  /** Resuelve con la clase global `JitsiMeetExternalAPI` lista para instanciar. */
  load(): Promise<any> {
    if (this.sdkPromise) return this.sdkPromise;

    this.sdkPromise = new Promise<any>((resolve, reject) => {
      // Ya cargado en una visita anterior.
      if (window.JitsiMeetExternalAPI) {
        resolve(window.JitsiMeetExternalAPI);
        return;
      }

      const existing = document.getElementById(
        JITSI_SCRIPT_ID
      ) as HTMLScriptElement | null;

      const onReady = () => {
        if (window.JitsiMeetExternalAPI) {
          resolve(window.JitsiMeetExternalAPI);
        } else {
          reject(new Error('Jitsi cargado pero JitsiMeetExternalAPI no está disponible'));
        }
      };

      if (existing) {
        existing.addEventListener('load', onReady);
        existing.addEventListener('error', () =>
          reject(new Error('No se pudo cargar el SDK de Jitsi'))
        );
        return;
      }

      const script = document.createElement('script');
      script.id = JITSI_SCRIPT_ID;
      script.async = true;
      script.src = JITSI_SCRIPT_SRC;
      script.onload = onReady;
      script.onerror = () => reject(new Error('No se pudo cargar el SDK de Jitsi'));
      document.body.appendChild(script);
    });

    return this.sdkPromise;
  }
}
